import { isValidIpOrCidr } from '@shared/validators/validators';

export function splitSubContent(text: string): string[] {
  return text
    .split(/[\s,;]+/)
    .map((s) => s.trim())
    .filter((s) => s !== '');
}

export function splitClipboard(clipboardEvent: ClipboardEvent): string[] {
  const clipData = clipboardEvent.clipboardData.getData('text/plain');
  if (clipData != null) {
    clipboardEvent.preventDefault();
    clipboardEvent.stopPropagation();
    return splitSubContent(clipData);
  }
  return [];
}

export function splitCsvLine(line: string): string[] {
  const fields: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];

    if (inQuotes) {
      if (char === '"') {
        if (line[i + 1] === '"') {
          current += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        current += char;
      }
    } else if (char === '"') {
      inQuotes = true;
    } else if (char === '\t' || char === ';' || char === ',') {
      fields.push(current);
      current = '';
    } else {
      current += char;
    }
  }
  fields.push(current);
  return fields;
}

export function parseBulkLines(text: string): { ip: string; comment?: string }[] {
  return (text ?? '')
    .split(/\r?\n/)
    .map((l) => l.replace(/\s+$/, ''))
    .filter((l) => l.trim() !== '')
    .flatMap((line) => {
      const parts = splitCsvLine(line)
        .map((p) => p.trim())
        .filter((p) => p !== '');

      if (!parts.length) return [];

      if (parts.length > 1 && !isValidIpOrCidr(parts[0]) && !isValidIpOrCidr(parts[1])) {
        return [];
      }

      if (parts.length === 1) return [{ ip: parts[0] }];

      if (parts.every((p) => isValidIpOrCidr(p))) {
        return parts.map((ip) => ({ ip }));
      }

      const [ip, ...rest] = parts;
      return [{ ip, comment: rest.join(' ') || undefined }];
    });
}
